import script from "./Ellipsis.vue?vue&type=script&setup=true&lang=js"
export * from "./Ellipsis.vue?vue&type=script&setup=true&lang=js"

import "./Ellipsis.vue?vue&type=style&index=0&id=2246eeba&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2246eeba"]])

export default __exports__